import {
  CustomMappingOption,
  ITranslationMap,
  type ICustomMappingSourceOption,
} from '@principle-theorem/practice-migrations/interfaces';
import {
  type AtLeast,
  type IXSLXExport,
  type XSLXCell,
} from '@principle-theorem/shared';
import type { Column } from 'exceljs';
import { ItemCodeNoteType } from '../../../mappings/item-codes-to-notes-xlsx';

export interface IPatientNoteTypeToNoteXSLX {
  sourceId: string;
  sourceName: string;
  mapTo: string;
}

export const PATIENT_NOTE_TYPE_TO_NOTE_HEADERS: AtLeast<
  Column,
  'key' | 'header'
>[] = [
  {
    key: 'sourceId',
    header: 'Id',
  },
  {
    key: 'sourceName',
    header: 'Patient Note Type',
    width: 45,
  },
  {
    key: 'mapTo',
    header: 'Map To',
    width: 30,
  },
];

export class PatientNoteTypeToNoteToXSLX
  implements
    IXSLXExport<ICustomMappingSourceOption, IPatientNoteTypeToNoteXSLX>
{
  headers = PATIENT_NOTE_TYPE_TO_NOTE_HEADERS;

  constructor(
    private _itemCodeNoteOptions: CustomMappingOption[],
    private _existingMappings: ITranslationMap<object, ItemCodeNoteType>[]
  ) {}

  translate(
    records: ICustomMappingSourceOption[]
  ): Record<keyof IPatientNoteTypeToNoteXSLX, XSLXCell>[] {
    return records.map((record) => {
      const existingRecord = this._existingMappings.find(
        (existingMapping) => existingMapping.sourceIdentifier === record.value
      );

      const destinationIdentifier = existingRecord?.destinationValue;
      const mappedValue = destinationIdentifier
        ? this._itemCodeNoteOptions.find(
            (itemCodeNoteOption) =>
              itemCodeNoteOption.value === destinationIdentifier.value
          )
        : undefined;

      return {
        sourceId: {
          value: record.value,
        },
        sourceName: {
          value: record.label,
        },
        mapTo: {
          value: mappedValue?.description,
          dataValidation: {
            type: 'list',
            formulae: [
              `"${this._itemCodeNoteOptions
                .map((itemCodeNoteOption) => itemCodeNoteOption.description)
                .join(',')}"`,
            ],
          },
        },
      };
    });
  }
}
